import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
import EventCardList from "./EventCardList";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import DateHelpers from "../Helper/DateHelpers";
import InputValidation from "../Helper/InputValidation";
import DataAccessHelper from "../Helper/DataAccessHelper";
import '../Styles/DayCampRegistrationReview.scss';


function DayCampRegistrationReview({currentRegistrant, buddyFirstName, buddyLastName, camperSignature, parentSignature,
   parentSignatureDate, weekSelection, authorizedIndividuals, personalInformation, medicalInformation, ProcessRegistration,
   selectedPage, setSelectedPage, isAdmin=false, AddToCart}){

   const [addToCartError, setAddToCartError] = useState('')
   const [addingToCart, setAddingToCart] = useState(false)

   // Deaf Day Camp is free and has never collected payment, so it still registers directly rather
   // than taking a detour through a cart that would have nothing to charge for. The admin screen
   // reuses this component without a cart, so it keeps going straight to the payment step.
   async function handleNext() {
      if (weekSelection.camp_type === "Deaf Day Camp") {
         ProcessRegistration()
         return
      }
      if (isAdmin || !AddToCart) {
         setSelectedPage(DayCampPageOptions.Payment)
         return
      }
      setAddingToCart(true)
      setAddToCartError('')
      const message = await AddToCart()
      if (message) {
         setAddToCartError(message)
         setAddingToCart(false)
      }
   }
      console.log("Personal Information", personalInformation)
      console.log("medical info", medicalInformation)
      console.log("authorized Individauls", authorizedIndividuals)
      console.log("week selected", weekSelection)
   return(
         <div className="DayCampRegistrationReviewContent">
            <div className="DayCampRegistrationReviewHeading">
               Review Your Information
            </div>
            <div className="DayCampRegistrationReviewFields">
               <div className="DayCampRegistrationReviewPersonalInfo">
                  <div className="DayCampRegistrationReviewPersonalInfoHeading">
                     Personal Information
                  </div>
                  <div className="DayCampRegistrationReviewPersonalInfoDetails">
                     <div className="DayCampRegistrationReviewPersonalInfoField">
                        Name: {personalInformation.firstName + " " + personalInformation.lastName}
                     </div>
                     <div className="DayCampRegistrationReviewPersonalInfoField">
                        Gender: {personalInformation.gender}
                     </div>
                     <div className="DayCampRegistrationReviewPersonalInfoField">
                        Date of Birth: {DateHelpers.getDisplayDate(personalInformation.birthDate)}
                     </div>
                     <div className="DayCampRegistrationReviewPersonalInfoField">
                        Address: {personalInformation.strAddress}
                     </div>
                     <div className="DayCampRegistrationReviewPersonalInfoField">
                        City: {personalInformation.city}
                     </div>
                     <div className="DayCampRegistrationReviewPersonalInfoField">
                        State: {personalInformation.state}
                     </div>
                     <div className="DayCampRegistrationReviewPersonalInfoField">
                        Zip: {personalInformation.zip}
                     </div>
                     <div className="DayCampRegistrationReviewPersonalInfoField">
                        Phone: {personalInformation.phone}
                     </div>
                  </div>
               </div>
               <div className="DayCampRegistrationReviewMedicalInfo">
                  <div className="DayCampRegistrationReviewMedicalInfoHeading">
                     Medical and Insurance Information
                  </div>
                  <div className="DayCampRegistrationReviewMedicalInfoDetails">
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Insurance Company: {medicalInformation.insuranceCompany}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Id Number: {medicalInformation.insuranceId}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Group Policy Number: {medicalInformation.groupPolicyNumber}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Name of Policyholder: {medicalInformation.policyHolderName}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Birthdate of Policyholder: {medicalInformation.policyHolderBirthdate === null ? "" : DateHelpers.getDisplayDate(medicalInformation.policyHolderBirthdate)}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has Diabetes/Hypoglycemia: {medicalInformation.hasDiabetes}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has Thyroid Problem: {medicalInformation.hasThyroidProblem}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has Heart Condition: {medicalInformation.hasHeartCondition}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has Lupus: {medicalInformation.hasLupus}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has Epilepsy: {medicalInformation.hasEpilepsy}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has High Blood Pressure: {medicalInformation.hasHighBloodPressure}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has Enviromental Allergies: {medicalInformation.hasEnvironmentalAllergies}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has Heat Exhaustion Problem: {medicalInformation.hasHeatExhaustion}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Has Asthma: {medicalInformation.hasAsthma}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Drug Allergy: {medicalInformation.drugAllergies}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Emergency Action: {medicalInformation.emergencyAction1}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Food Allergy: {medicalInformation.foodAllergies}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Emergency Action: {medicalInformation.emergencyAction2}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Other Allergy: {medicalInformation.otherAllergies}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Emergency Action: {medicalInformation.emergencyAction3}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Medication Name: {medicalInformation.medicationName}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Medication Dose: {medicalInformation.medicationDose}
                     </div>
                     <div className="DayCampRegistrationReviewMedicalInfoField">
                        Date of Last Tetanus Shot: {medicalInformation.tetanusShotDate === null ? "" : DateHelpers.getDisplayDate(medicalInformation.tetanusShotDate)}
                     </div>
                  </div>
               </div>
               <div className="DayCampRegistrationReviewEventInfo">
                  <div className="DayCampRegistrationReviewEventInfoHeading">
                     Selected Week Information
                  </div>
                  <div className="DayCampRegistrationReviewEventInfoDetails">
                     <div className="DayCampRegistrationReviewEventInfoField">
                        Week Selected: {weekSelection.camp_name}
                     </div>
                     <div className="DayCampRegistrationReviewEventInfoField">
                        Dates: {DateHelpers.getEventDateRange(weekSelection.begin_date, weekSelection.end_date)}
                     </div>
                     <div className="DayCampRegistrationReviewEventInfoField">
                        Buddy Selection: {buddyFirstName + " " + buddyLastName}
                     </div>
                     <div className="DayCampRegistrationReviewEventInfoField">
                        Authorized Individuals: 
                     </div>
                  </div>
               </div>
              
            </div>
            {addToCartError &&
               <div className="DayCampRegistrationReviewError">
                  {addToCartError}
               </div>
            }
            <div className="DayCampRegistrationReviewButtons">
               <div className="DayCampRegistrationReviewPreviousButton">
                  <button onClick={() => setSelectedPage(DayCampPageOptions.ParentConsent)} disabled={addingToCart}>
                     Previous
                  </button>
               </div>
               <div className="DayCampRegistrationReviewNextButton">
               <button onClick={handleNext} disabled={addingToCart}>
                  {weekSelection.camp_type === "Deaf Day Camp"
                     ? 'Complete Registration'
                     : (isAdmin || !AddToCart) ? 'Pay'
                     : addingToCart ? 'Adding…' : 'Add to Cart'}
               </button>
               { isAdmin &&
                  <button onClick={() => setSelectedPage(DayCampPageOptions.PaymentCashCheck)}>
                     Cash/Check Payments
                  </button>
               }
               </div>
            </div>
         </div>
   )
}

export default DayCampRegistrationReview
